"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/**
 * - Hook that accept a function and returns the debounce memorized version.
 * - if the function dont have delay propierty in the parameters will return the current Function.
 */
function useDebounce(_ref) {
  var fn = _ref.fn,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$dependencies = _ref.dependencies,
    dependencies = _ref$dependencies === void 0 ? [] : _ref$dependencies;
  if (delay > 0) {
    // Memorized With Optional Dependencies
    return (0, _react.useCallback)((0, _debounce["default"])(fn, delay), dependencies);
  }
  return fn;
}
var _default = useDebounce;
exports["default"] = _default;